var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4859 18.3923C5.88349 18.3923 2.15253 14.6613 2.15253 10.0589C2.15253 5.45654 5.88349 1.72559 10.4859 1.72559C15.0882 1.72559 18.8192 5.45654 18.8192 10.0589C18.8192 14.6613 15.0882 18.3923 10.4859 18.3923ZM9.65253 9.22559H6.31919V10.8923H9.65253V14.2256H11.3192V10.8923H14.6525V9.22559H11.3192V5.89225H9.65253V9.22559Z",
    fill: "#A4A6A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupImg);
export default __webpack_public_path__ + "static/media/groupImg.79c8e46f98cfc14d3ebd041b8b1ff2e6.svg";
export { ForwardRef as ReactComponent };